export default __webpack_public_path__ + "static/pcr-testing-527cafe7b649730422f073acae013d3b.png";